import { render, staticRenderFns } from "./UpdateClient.vue?vue&type=template&id=4b52b785&"
import script from "./UpdateClient.vue?vue&type=script&lang=ts&"
export * from "./UpdateClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports